import { useTranslation } from 'react-i18next'
import RequiredConfirmationDialog from '../Common/Dialog/RequiredConfirmationDialog'

interface RefetchSimulationAlertProps {
  refetch: () => void
}

const RefetchSimulationAlert = ({ refetch }: RefetchSimulationAlertProps) => {
  const { t } = useTranslation()
  return (
    <RequiredConfirmationDialog onConfirm={refetch} title={t('loan.conflict.title')}>
      {t('loan.conflict.message')}
    </RequiredConfirmationDialog>
  )
}

export default RefetchSimulationAlert
